// extracted by mini-css-extract-plugin
export default {"cluster_marker":"style_cluster_marker__uCRYg","crime_marker":"style_crime_marker__u+VE7","service_marker":"style_service_marker__An6Mu"};